import { MembersListTab } from './types';

export const MEMBERS_LIST_TAB_PARAM = 'tab';
export const DEFAULT_MEMBERS_LIST_TAB: MembersListTab = 'members';
export const MEMBERS_LIST_TABS: MembersListTab[] = ['members', 'allow-list'];
